import { useRecoilState } from 'recoil'
import { selectedGameState } from '../../../common/atoms/atoms'
import React from 'react'
import { GameCategories } from '../../../common/enums/game-categories'
import BlackFridayBannerV2 from './BlackFridayBannerV2'

export default function HolidayBannerByGame() {
  const [game] = useRecoilState(selectedGameState)
  const Banner = filterBanner(game?.key)

  function filterBanner(game: string) {
    // return <MemorialDayBanner />
    switch (game) {
      case GameCategories.leagueOfLegends:
        return <BlackFridayBannerV2 />
      case GameCategories.valorant:
        return <BlackFridayBannerV2 />
      case GameCategories.fortnite:
        return <BlackFridayBannerV2 />
      default:
        return <BlackFridayBannerV2 />
    }
  }
  return <>{Banner && Banner}</>
}
